import { SearchUserEnriched } from 'lib-search-types';
import { User } from 'lib-shared-types-api';
import { useMemo } from 'react';

import { AwayStatus } from 'apis/presence';
import { PresenceRowSelection } from 'components/presence/components/presenceListItem';
import { PresenceSection } from 'components/presence/components/presenceSection';
import { CollapsedSections } from 'components/presence/hooks/useCollapsedSections';
import { groupMembersByStatus } from 'components/presence/utils';

type StatusPresenceListSectionsProps = {
  members: SearchUserEnriched[];
  profile: User;
  awayStatuses: AwayStatus[];
  selection: PresenceRowSelection;
  collapsedSections?: CollapsedSections;
};

/** One section each for working, away and offline members. */
export const StatusPresenceListSections = ({
  members,
  profile,
  awayStatuses,
  selection,
  collapsedSections,
}: StatusPresenceListSectionsProps): JSX.Element => {
  const groupedMembers = useMemo(
    () => groupMembersByStatus(members, profile.id),
    [members, profile.id],
  );

  return (
    <>
      {groupedMembers.map((group) => (
        <PresenceSection
          key={group.status}
          id={group.status}
          title={group.status}
          count={group.members.length}
          members={group.members}
          profile={profile}
          awayStatuses={awayStatuses}
          selection={selection}
          collapsedSections={collapsedSections}
        />
      ))}
    </>
  );
};
